import { useQuery } from 'react-query';

import { getTrapDetailPieActivationsChartData } from 'api/traps/Trap/getTrapDetailPieActivationsChartData';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export const useGetTrapDetailPieActivationsChartData = (slug: string, type: TrapType) => {
  const { data, isLoading, isFetching } = useQuery(
    ['TrapDetailPieActivationsChartData', slug, type],
    () => getTrapDetailPieActivationsChartData(slug, type),
    {
      refetchOnWindowFocus: false,
    },
  );

  return { data, isLoading, isFetching };
};
